import InOrderIterator from './in-order-iterator';

export default class Base {
  selectedAttribute = 'selected';

  constructor({
    containerSelector,
    elementSelector,
    thumbnailSelector = null,
    iteratorClass = InOrderIterator
  }) {
    this.container = document.querySelector(containerSelector);
    this.thumbnailSelector = thumbnailSelector;
    this.elementSelector = elementSelector;
    this.IteratorClass = iteratorClass;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.touchThreshold = 50;
  }

  getCount = () => parseInt(this.container.dataset.count);

  iterator = () => new this.IteratorClass({ count: this.getCount(), selectedIndex: this.getSelectedIndex() });

  selectNext = () => {
    const nextIndex = this.iterator().getNextIndex();

    this.selectElement(nextIndex);
  };

  selectPrevious = () => {
    const previousIndex = this.iterator().getPreviousIndex();

    this.selectElement(previousIndex);
  };

  selectElement = (index) => {
    this.getSelectedElement().removeAttribute(this.selectedAttribute);
    this.getElementByIndex(index).setAttribute(this.selectedAttribute, '');

    this.thumbnails().forEach((thumbnail) => {
      if (parseInt(thumbnail.dataset.index) === parseInt(index)) {
        thumbnail.setAttribute(this.selectedAttribute, '');
      } else {
        thumbnail.removeAttribute(this.selectedAttribute);
      }
    });
  };

  thumbnails = () => {
    if (!this.thumbnailSelector) {
      return [];
    }

    return [...this.container.querySelectorAll(`.${this.thumbnailSelector}`)];
  };

  getElementByIndex = (index) => this.container.querySelector(`.${this.elementSelector}[data-index="${index}"]`);
  getSelectedElement = () => this.container.querySelector(`.${this.elementSelector}[${this.selectedAttribute}]`);
  getSelectedIndex = () => parseInt(this.getSelectedElement().dataset.index);

  handleThumbnailClick = ({ currentTarget: { dataset: { index }}}) => {
    this.selectElement(index);
  };

  handleTouchStart({ changedTouches }) {
    this.touchstartX = changedTouches[0].clientX;
  }

  handleTouchEnd({ changedTouches }) {
    const touchendX = changedTouches[0].clientX;

    if (this.touchstartX < touchendX - this.touchThreshold) {
      this.selectPrevious();
    }

    if (this.touchstartX > touchendX + this.touchThreshold) {
      this.selectNext();
    }
  }

  initializeEventListeners() {
    if (this.container) {
      this.thumbnails().forEach((thumbnail) => thumbnail.addEventListener('click', this.handleThumbnailClick));
    }
  }
}
